module.exports = "<input type=\"text\" ng-model=\"ctrl.selected\" uib-typeahead=\"choice for choice in ctrl.choices | filter:$viewValue | limitTo:8\"\n       typeahead-min-length=\"ctrl.minlength\" class=\"form-control\" typeahead-on-select=\"ctrl.onChange()\" placeholder=\"{{ctrl.placeholder}}\" />\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/autocomplete-redirect/autocomplete-redirect.html
// module id = 654
// module chunks = 0